.tooltipWrapper {
  border-radius: 5px;
  padding: 10px;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.titleWrapper {
  border-bottom: 2px solid gray;
}

.legendWrapper {
  display: flex;
  justify-content: space-between;
  gap: 5px;
}

.lwLeft {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
